import EmployeeLeaves from "./EmployeeLeaves";
export default EmployeeLeaves;